// Modules
import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';

// Interfaces
import {
  IAppConfig,
  IAppGeneralConfig,
  IFianzaModuleConfig,
  ICarInsuranceModuleConfig,
  IUsersModuleConfig,
  IAccidentsModuleConfig,
  ICouponsCampaignModuleConfig,
  IAccountsModuleConfig,
  ICarteraModuleConfig,
  ICnnSignalRModuleConfig,
  IMultiproductsModuleConfig,
  IMicrosoft365Config,
} from '@shared/interfaces';

// Environment
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  // Private variables
  private _appConfig: IAppConfig;
  // Constructor
  constructor(private _handler: HttpBackend) {}

  // Get auth base url
  get authBaseUrl(): string {
    return this._appConfig.general.authBaseUrl;
  }

  // Get logged user session key
  get loggedUserSessionKey(): string {
    return this._appConfig.general.loggedUserSessionKey;
  }

  // Get menu memory session key
  get menuMemoryKey(): string {
    return this._appConfig.general.menuMemory;
  }

  //Obtener mail de sbi
  get sbiMail(): string {
    return this._appConfig.general.sbiMail;
  }

  //Obtener maximo de cuotas para alta de producto
  get maxInstallments(): number {
    return this._appConfig.general.maxInstallments;
  }

  // Get menu memory session key
  get loggedUserData(): string {
    return this._appConfig.general.loggedUserData;
  }

  get environment(): string {
    return this._appConfig.general.environment;
  }

  // Get app general config
  get generalConfig(): IAppGeneralConfig {
    return this._appConfig.general;
  }

  // Get Fianza config
  get fianzaConfig(): IFianzaModuleConfig {
    return this._appConfig.fianza;
  }

  // Get Car Insurance config
  get carInsuranceConfig(): ICarInsuranceModuleConfig {
    return this._appConfig.carInsurance;
  }

  get usersConfig(): IUsersModuleConfig {
    return this._appConfig.users;
  }

  get accidentsConfig(): IAccidentsModuleConfig {
    return this._appConfig.accidents;
  }

  get couponsCampaignConfig(): ICouponsCampaignModuleConfig {
    return this._appConfig.couponsCampaign;
  }

  get accountsConfig(): IAccountsModuleConfig {
    return this._appConfig.accounts;
  }

  // Obtener configuracion de modulo de cartera
  get carteraConfig(): ICarteraModuleConfig {
    return this._appConfig.cartera;
  }

  get signalRConfig(): ICnnSignalRModuleConfig {
    return this._appConfig.signalRConfig;
  }

  get multiproductsConfig(): IMultiproductsModuleConfig {
    return this._appConfig.multiproducts;
  }

  get microsoft365(): IMicrosoft365Config {
    return this._appConfig.microsoft365;
  }

  // Public method to load the config file
  public loadAppConfig(): Promise<void> {
    const http = new HttpClient(this._handler);

    return http
      .get(environment.configFile)
      .toPromise()
      .then((response: IAppConfig) => {
        this._appConfig = response;
        return this._loadGoogleMapsScript(response.googleMapsApiKey);
      });
  }

  private _loadGoogleMapsScript(apiKey: string): Promise<void> {
    return new Promise(resolve => {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
      script.async = true;
      script.onload = () => resolve();
      // Resolve on error so a Maps failure never blocks the app from starting
      script.onerror = () => resolve();
      document.head.appendChild(script);
    });
  }
}
